import { DecisionSwal } from "../../../../../Utils/Utils/DecisionSwal";
import { ESTADOS_INV_ALMACEN } from "../../../../../../../utility/constants";

export const getReajusteCellStyle = (item, estaCerrado, hoveredId) => {
    const isHovered = estaCerrado ? false : hoveredId === item.almacen_id;

    return {
        cursor: !estaCerrado ? "pointer" : "default",
        backgroundColor:
            item.anterior && item.anterior.inv_inicial_reajustado
                ? "#fff3cd" // si ya fue reajustado
                : isHovered
                  ? "#f5f5f5" // color de hover
                  : "transparent",
        transition: "background-color 0.2s ease",
    };
};

export const getIngresosCellStyle = (item, hoveredId) => {
    const isHovered = hoveredId === item.almacen_id;

    return {
        cursor: "pointer",
        backgroundColor: item.ingresos_periodo.drc_faltante
            ? "rgb(240 62 79)"
            : isHovered
              ? "#f5f5f5" // color de hover
              : "transparent",
        color: item.ingresos_periodo.drc_faltante ? "#fff" : "inherit",
        // font-weight
        fontWeight: item.ingresos_periodo.drc_faltante ? "bold" : "normal",
        transition: "background-color 0.2s ease",
    };
};

// Recepciones y análisis que se borran al fijar el inventario final sin procesar el sobrante
const describirDatosDescartables = (item) => {
    const cantidadRecepciones = item.actual.cantidad_recepciones_seleccionadas;
    const descartables = [];

    if (cantidadRecepciones === 1) {
        descartables.push("1 recepción seleccionada");
    } else if (cantidadRecepciones > 1) {
        descartables.push(`${cantidadRecepciones} recepciones seleccionadas`);
    }

    if (item.actual.tiene_analisis_sobrante) {
        descartables.push("el análisis DRC del sobrante");
    }

    return descartables;
};

const confirmarSiDescartaDatos = (item, descripcionAccion, aplicarAccion) => {
    const descartables = describirDatosDescartables(item);

    if (!descartables.length) {
        aplicarAccion();
        return;
    }

    const esPlural =
        descartables.length > 1 ||
        item.actual.cantidad_recepciones_seleccionadas > 1;
    const verbo = esPlural ? "Se descartarán" : "Se descartará";

    let mensaje = `${descripcionAccion} ${verbo} ${descartables.join(" y ")}, `;
    mensaje += "información que no podrá recuperarse. ¿Desea continuar?";

    DecisionSwal(mensaje, "Sí", "No", aplicarAccion);
};

export const MarcarInventarioSinCambios = (item, ActualizarEstadoAlmacen) => {
    confirmarSiDescartaDatos(
        item,
        "El inventario final de este almacén será su inventario inicial más los ingresos del periodo.",
        () =>
            ActualizarEstadoAlmacen(
                item.inventario_almacen_id,
                ESTADOS_INV_ALMACEN.SIN_CAMBIOS,
            ),
    );
};

export const MarcarInventarioVacio = (item, ActualizarEstadoAlmacen) => {
    confirmarSiDescartaDatos(
        item,
        "El inventario final de este almacén quedará en 0 kg en laboratorio y en liquidación.",
        () =>
            ActualizarEstadoAlmacen(
                item.inventario_almacen_id,
                ESTADOS_INV_ALMACEN.CERO,
            ),
    );
};
